__turbopack_context__.v({
  "bottom-shadow-curtain": "modal-module-scss-module__JTOPvG__bottom-shadow-curtain",
  "content-desktop-in": "modal-module-scss-module__JTOPvG__content-desktop-in",
  "content-desktop-out": "modal-module-scss-module__JTOPvG__content-desktop-out",
  "content-mobile-in": "modal-module-scss-module__JTOPvG__content-mobile-in",
  "content-mobile-out": "modal-module-scss-module__JTOPvG__content-mobile-out",
  "content-wrapper": "modal-module-scss-module__JTOPvG__content-wrapper",
  "modal-content": "modal-module-scss-module__JTOPvG__modal-content",
  "modal-footer": "modal-module-scss-module__JTOPvG__modal-footer",
  "modal-surface": "modal-module-scss-module__JTOPvG__modal-surface",
  "overaly-in": "modal-module-scss-module__JTOPvG__overaly-in",
  "overaly-out": "modal-module-scss-module__JTOPvG__overaly-out",
  "overlay": "modal-module-scss-module__JTOPvG__overlay",
});
